import { useAppointment } from '@hook'
import { BinIcon } from '@icons'
import { useAppDispatch } from '@store/hooks'
import { hideDoctorAppointment } from '@store/slicers/ModalSlicer'
import { Button, Modal } from '@ui'
import { getError, showToast } from '@util'
import { Box, Text } from 'grommet'
import { Checkmark, Close } from 'grommet-icons'
import { useState } from 'react'

type Props = {
  onClose: () => void
  id?: string
  defaultData?: Record<string, unknown>
}

export const RemoveAppointment = ({ onClose, id = '', defaultData }: Props) => {
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const { updateAppointment } = useAppointment()

  const handleSubmit = async () => {
    const payload = {
      data: {
        attributes: {
          purpose: 'cancelled',
          status: 'cancelled',
          ...defaultData
        },
        type: 'appointment'
      }
    }
    setLoading(true)
    try {
      await updateAppointment({ data: payload, id })
      setLoading(false)
      dispatch(hideDoctorAppointment())
      showToast('Appointment cancelled successfully')
      onClose()
    } catch (err) {
      getError(err)
      setLoading(false)
    }
  }

  return (
    <Modal onClose={onClose} title="Cancel Appointment">
      <Box align="center" justify="center" pad={{ horizontal: '24px', vertical: '20px' }} width="100%">
        <Box align="center" justify="center" margin={{ bottom: 'small' }}>
          <BinIcon />
        </Box>
        <Box gap="small" margin={{ bottom: 'small' }} width="281px">
          <Text color="#999999" margin="small" size="14px" textAlign="center">
            Please confirm you want to cancel this Appointment
          </Text>
        </Box>
        <Box direction="row" flex gap="16px" justify="center" width="100%">
          <Button
            color="#F5F5F5"
            icon={<Close size="small" />}
            kinds="secondary"
            label="No, Keep"
            onClick={onClose}
            size={'wide'}
          />
          <Button
            icon={<Checkmark size="small" />}
            isLoading={loading}
            label="Yes, Cancel"
            onClick={handleSubmit}
            size={'wide'}
          />
        </Box>
      </Box>
    </Modal>
  )
}
